export const LIGHT_MODE_COLORS = {
  //Blacks
  BLACK_100: '#202020',
  BLACK_200: '#2F2F2F',
  BLACK_300: '#231800',
  BLACK_400: '#1E1E1E',
  BLACK_500: 'rgba(0, 0, 0, 0.21)',
  BLACK_600: 'rgba(0, 0, 0, 0.04)',
  BLACK_700: '#0000003D',
  BLACK_800: 'rgba(0, 0, 0, 0.40)',
  BLACK_900: 'rgba(0, 0, 0, 0.58)',
  BLACK_1000: '#3A3634',
  BLACK_1100: '#212121',
  BLACK_1200: '#FFFFFF17',

  // Blues
  BLUE_100: '#F7FDFC',
  BLUE_200: '#0E7EE7',
  BLUE_300: '#0E7EE71C',
  BLUE_400: '#E6F3FF',
  BLUE_500: '#9DDAFC',

  // Greens
  GREEN_100: '#00C8B4',
  GREEN_200: '#008578',
  GREEN_300: '#0085781F',
  GREEN_400: '#01CEBA',
  GREEN_500: '#0FAC1F',
  GREEN_600: '#008E39',

  // Greys
  LIGHT_GREY_100: '#F3F4F6',
  LIGHT_GREY_200: '#FAFAFA',
  LIGHT_GREY_300: '#FCFCFD',
  LIGHT_GREY_400: 'rgba(182, 187, 192, 0.20)',
  LIGHT_GREY_500: 'rgba(182, 187, 192, 0.10)',
  LIGHT_GREY_600: '#D5D8DD',
  LIGHT_GREY_700: '#F7F8FA',
  LIGHT_GREY_800: '#F4F5F6',
  LIGHT_GREY_900: '#e3e3e3',
  LIGHT_GREY_1000: '#E6E9EF',
  LIGHT_GREY_1100: '#EBF1F7',
  LIGHT_GREY_1200: 'rgba(255, 255, 255, 0.40)',
  DARK_GREY_100: '#4F4F4F',
  DARK_GREY_200: '#B6BBC0',

  // Reds
  RED_100: '#E03C311F',
  RED_200: '#E03C31',
  RED_300: '#FF4C40',

  // Yellows
  YELLOW_100: '#FFD80B',
  YELLOW_200: '#FFF8E2',
  YELLOW_300: '#FFF2C4',
  YELLOW_400: '#FFBE19',
  YELLOW_500: 'rgba(255, 238, 185, 0.40)',
  YELLOW_600: '#FFDA57',
  YELLOW_700: '#FFCB52',
  YELLOW_800: '#FEB521',
  YELLOW_900: '#FE9A00',

  // Whites
  WHITE_100: '#FEFEFE',
  WHITE_200: 'rgba(255, 255, 255, 0.12)',
  WHITE_300: 'rgba(255, 255, 255, 0.48)',
  WHITE_400: 'rgba(182, 187, 192, 0.12)',
  WHITE_500: 'rgba(255, 255, 255, 0.80)',
  WHITE_600: 'rgba(255, 255, 255, 0.55)',
  WHITE_700: 'rgba(255, 255, 255, 0.61)',
};

export const DARK_MODE_COLORS = {};

export const COMMON_COLORS = {
  BLACK: '#1A1A1A',
  GREY_100: '#DBDBDB',
  GREY_200: '#989898',
  GREY_300: '#EDF0FC',
  GREY_400: '#aaaaaa',
  GREY_500: 'rgba(182, 187, 192, 0.30)',
  GREY_600: '#8080804D',
  GREY_700: '#E9EBEC',
  GREY_800: '#7A7A7A',
  GREY_900: '#E6E8EC1F',
  WHITE: '#fff',
  YELLOW: '#FFAA00',
  YELLOW_100: '#FFD80B',
  YELLOW_200: '#FFD279',
  YELLOW_300: '#FFE7B8',
  YELLOW_400: '#FA0',
  YELLOW_500: '#FFB81C',
  YELLOW_600: '#FFEEB9',
  YELLOW_700: '#F9C935',
  YELLOW_800: '#FFD570',
  YELLOW_900: '#FBBD2D38',
  RED: '#E03C31',
  RED_100: '#F8645A',
  RED_200: '#FBE6E4',
  RED_300: '#F8F7CF',
  RED_400: '#F54C4C',
  GREEN: '#008578',
  GREEN_100: '#01C9B5',
  GREEN_200: '#008578',
  BLUE: '#046BCB',
  SLATE : '#90A1B9',
  SLATE_LIGHT : '#cad5e2',
};
